import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import MCertification from '../molecules/_molecules.certification';

export default function OCertification({ items }) {
	return (
		<article className="o-default-article">
			<h2>
				<FormattedMessage id="ABOUT_US.CERTIFICATION" defaultMessage="" />
			</h2>
			<MCertification items={items} />
		</article>
	);
}

OCertification.propTypes = {
	items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.certification.js